import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles(() => ({
  pressReleaseCard: {
    padding: "1rem",
    width: "100%",
  },
}));
